import { useEffect, useContext } from "react";
import UserContext from "../UserContext";
import useApi from "../apiProvider";
import { getEnv } from "../environment";

const env = getEnv();

const LandingPage = () => {
  const userContext = useContext(UserContext);
  const userGmid = userContext?.uid ? userContext.uid : "N/A";
  const speedTestUrl = env.speedTestUrl;

  useEffect(() => {
    const testCompleted = (event) => {
      if (event.origin === speedTestUrl) {
        const speedResultData = {
          userGmid,
          downloadSpeed: parseFloat(event.data.download),
          uploadSpeed: parseFloat(event.data.upload),
          minLatency: parseFloat(event.data.latency.minimum),
          latencyJitter: parseFloat(event.data.latency.jitter),
          serverHost: event.data.config.host,
          serverPort: parseInt(event.data.config.port),
          serverId: parseInt(event.data.config.serverId),
          serverVersion: event.data.config.serverVersion,
          testId: event.data.config.testId,
          testMethod: event.data.config.testMethod,
          testStart: event.data.start.timestamp,
          testEnd: event.data.end.timestamp,
          devicePlatform: event.data.device.platform,
        };
        useApi.createNewSpeedTestResult(speedResultData);
      }
    };
    window.addEventListener("message", testCompleted);
    return () => {
      window.removeEventListener("message", testCompleted);
    };
  }, [speedTestUrl, userGmid]);

  return (
    <iframe
      title="st"
      id="your-iframe"
      width="100%"
      height="650px"
      frameBorder="0"
      src={speedTestUrl}
    />
  );
};

export default LandingPage;
